import React from "react";

interface SearchQueryProps {
    searchQuery: string;
    setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
}

const SearchQuery: React.FC<SearchQueryProps> = ({ searchQuery, setSearchQuery }) => {
    return(
        <section className="search">
            <input 
                type="text" 
                placeholder="Search..." 
                className="search-table"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
            />
        </section>
    );
};

export default SearchQuery;
